import { validate } from 'uuid';
import { lengthenId } from './lengthenId';

export function validateId(id: string, short: boolean = false): boolean {
  const longId = short ? lengthenId(id) : id;
  return validate(longId);
}
